import { CAL_SERVER_ORDER_MNG } from '@/api/apiModules'
export default {
  viewType: 'table',
  module: CAL_SERVER_ORDER_MNG,
  sortArr: [
    {
      fieldName: 'createTime',
      direction: 'DESC'
    }
  ],
  refreshInterval: false,
  // relationSearch: true,
  allowStatus: {},
  toolbar: {
    searchPlaceholder: '请输入项目名称',
    moreBtnWidth: 160,
    searchFieldNameArr: ['customerName'],
    hasColAdjustment: true,
    items: [
      {
        slot: 'refresh-rigtht',
        label: '我要配置',
        props: {
          type: 'primary',
          icon: 'el-icon-plus'
        },
        action: 'calOrderCreate'
      }
    ]
  },

  view: {
    columns: [
      {
        props: {
          label: '项目名称',
          prop: 'customerName',
          sortField: 'customerName',
          width: 350
        }
      },
      {
        props: {
          label: '行业名称',
          prop: 'industryName',
          sortField: 'industryName'
        }
      },
      {
        props: {
          label: '创建时间',
          prop: 'createTime',
          sortField: 'createTime',
          width: 350
        },
        dataType: 'date'
      },
      {
        props: {
          label: '更新时间',
          prop: 'updateTime',
          sortField: 'updateTime',
          width: 350
        },
        dataType: 'date'
      },
      {
        //操作
        props: {
          showBtnNum: '3'
        },
        dataType: 'operation'
      }
    ],
    menus: [
      {
        icon: 'el-icon-edit',
        label: '编辑',
        command: 'calOrderEdit',
        name: 'edit'
      },
      {
        icon: 'el-icon-delete',
        label: 'delete',
        command: 'calOrderDelete',
        name: 'delete',
        confirm: {
          msg: '是否删除订单？'
        }
      },
      {
        icon: 'el-icon-edit',
        label: '导出Excel',
        command: 'segmentSceneExport',
        name: 'export'
      }
    ]
  }
}
